import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroSection = _resolveComponent("HeroSection")!
  const _component_DiscoverProperties = _resolveComponent("DiscoverProperties")!
  const _component_FeaturedProperties = _resolveComponent("FeaturedProperties")!
  const _component_WhyChooseUs = _resolveComponent("WhyChooseUs")!
  const _component_ReviewsSection = _resolveComponent("ReviewsSection")!
  const _component_BlogSection = _resolveComponent("BlogSection")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HeroSection),
    _createVNode(_component_DiscoverProperties),
    _createVNode(_component_FeaturedProperties),
    _createVNode(_component_WhyChooseUs),
    _createVNode(_component_ReviewsSection),
    _createVNode(_component_BlogSection)
  ]))
}